module.exports = __webpack_public_path__ + "img/img_guanyuwomen_neijuan@3x.adf78e4a.png";